import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpReferralsByServiceKeys = {
  all: ['analytics', 'fp-referrals-by-service'] as const,
  list: (params?: AnalyticsQueryParams) =>
    [...fpReferralsByServiceKeys.all, 'list', params] as const,
};

export const useFPReferralsByServiceData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpReferralsByServiceKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPReferralsByService(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
